export enum UserSection {
    MAIN_ACTIVITY='MAIN_ACTIVITY',
    USER_LIST_ACTIVITY='USER_LIST_ACTIVITY',
    ONE_USER_ACTIVITY='ONE_USER_ACTIVITY',
    MY_ACTIVITY='MY_ACTIVITY',
    DESTINATION='DESTINATION'
}